import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    LsqCoreModule,
    PhonePipe,
    LsqCommonModule,
    LsqTablesModule,
    ModalServiceToken,
    LsqModalsModule,
    ModalService,
    LsqFormsModule
} from '@lsq-frontend/common-ui';
import { ApiModule, BASE_PATH } from '@lsq-frontend/remote-services/ar-app';
import { environment } from '@lsq-frontend/fasttrack-shared/environment';
import { ReviewField } from './components/dr-review-field/dr-review-field.component';
import { DynamicContainerBase } from './components/dynamic-container-base/dynamic-container-base.component';
import { DynamicContainer } from './components/dynamic-container/dynamic-container.component';
import { DocumentField } from './components/dr-document-field/dr-document-field.component';
import { UploadDocumentModal } from './components/dr-document-field/upload-document-modal/upload-document-modal.component';
import { EditPhoneField } from './components/dr-edit-phone/dr-edit-phone.component';
import { AddDocumentField } from './components/dr-add-document-field/dr-add-document-field.component';
import { AddDocumentModal } from './components/dr-add-document-field/add-document-modal/add-document-modal.component';
import { AddDocumentListField } from './components/dr-add-document-list-field/dr-add-document-list-field.component';
import { AddDocumentListModal } from './components/dr-add-document-list-field/add-document-list-modal/add-document-list-modal.component';
import { DownloadAllDocumentsField } from './components/dr-download-all-documents-field/dr-download-all-documents-field.component';
import { ScheduleDocumentRequest } from './components/dr-schedule-document-request/dr-schedule-document-request.component';
import { ReviewStage } from './components/dr-review-stage/dr-review-stage.component';
import { RemoveDocumentModal } from './components/dr-document-field/remove-document-modal/remove-document-modal.component';
import { LabelField } from './components/dr-label-field/dr-label-field.component';
import { ReviewContainer } from './components/dr-review/dr-review.component';
import { DropdownField } from './components/dr-dropdown-field/dr-dropdown-field.component';
import { LinkedLabel } from './components/dr-label-field/linked-label/linked-label.component';
import { StringField } from './components/dr-string-field/dr-string-field.component';
import { EditPhoneModal } from './components/dr-edit-phone/edit-phone-modal/edit-phone-modal.component';
import { DynamicTab } from './components/dr-tab/dr-tab.component';
import { DynamicAudit } from './components/dr-audit/dr-audit.component';
import { ReviewStageBase } from './components/dr-review-stage-base/dr-review-stage-base.component';
import { ReviewContainerBase } from './components/dr-review-base/dr-review-base.component';
import { PopoverModule } from 'ngx-smart-popover';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PopoverModule,
        ApiModule,
        HttpClientModule,
        LsqCoreModule.forChild(),
        LsqCommonModule.forChild(),
        LsqTablesModule.forChild(),
        LsqFormsModule,
        LsqModalsModule
    ],
    declarations: [
        ReviewField,
        DynamicContainerBase,
        ReviewStageBase,
        ReviewContainerBase,
        DynamicContainer,
        DocumentField,
        UploadDocumentModal,
        EditPhoneField,
        AddDocumentModal,
        AddDocumentField,
        AddDocumentListField,
        AddDocumentListModal,
        DownloadAllDocumentsField,
        ScheduleDocumentRequest,
        ReviewStage,
        RemoveDocumentModal,
        LabelField,
        ReviewContainer,
        DropdownField,
        LinkedLabel,
        StringField,
        EditPhoneModal,
        DynamicTab,
        DynamicAudit
    ],
    exports: [
        ReviewField,
        DynamicContainerBase,
        ReviewStageBase,
        ReviewContainerBase,
        DynamicContainer,
        DocumentField,
        UploadDocumentModal,
        EditPhoneField,
        AddDocumentModal,
        AddDocumentField,
        AddDocumentListField,
        AddDocumentListModal,
        DownloadAllDocumentsField,
        ScheduleDocumentRequest,
        ReviewStage,
        RemoveDocumentModal,
        LabelField,
        ReviewContainer,
        DropdownField,
        LinkedLabel,
        StringField,
        EditPhoneModal,
        DynamicTab,
        DynamicAudit
    ],
    providers: [
        PhonePipe,
        { provide: ModalServiceToken, useExisting: ModalService },
        { provide: BASE_PATH, useValue: environment.httpApiServiceNameUrlMap.arApp }
    ]
})
export class DrApplicationSharedComponentsModule {
    constructor() {
        console.debug('Loading libs/DrApplicationSharedComponentsModule.');
    }
}
